<template>
  <div data-cy="parent-fields" class="d-flex-inline flex flex-col gap-3">
    <ParentCustomerLookup
      v-if="ready"
      v-model="parentId"
      :filter-id="customerId"
      name="Parent Customer"
      placeholder="Search Customers..."
      class="full-width"
      data-cy="parent-customer"
      :disabled="disableParent"
    />
    <div v-if="!disableDelegateBilling" class="ml-3 flex items-center">
      <Checkbox
        v-model="delegateBilling"
        label="Bill to Parent"
        :disabled="disableDelegateBilling"
      />
    </div>
  </div>
</template>

<script>
import Checkbox from "@/components/Checkbox.vue";
import ParentCustomerLookup from "@/Customer/ParentCustomerLookup.vue";
import useVuelidate from "@vuelidate/core";

export default {
  components: {
    Checkbox,
    ParentCustomerLookup
  },
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    disableParent: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:delegateBilling", "update:parentId"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  computed: {
    customerId: ({ formData }) => {
      return formData.id;
    },
    disableDelegateBilling: ({ parentId }) => {
      return !parentId;
    },
    delegateBilling: {
      get() {
        return this.formData.parent?.delegate_billing;
      },
      set(value) {
        this.$emit("update:delegateBilling", value);
      }
    },
    parentId: {
      get() {
        return this.formData.parent?.id;
      },
      set(value) {
        this.$emit("update:parentId", value);

        if (!value) {
          this.delegateBilling = false;
        }
      }
    },
    ready: ({ formData }) => {
      return !!formData;
    }
  }
};
</script>

<style lang="scss" scoped>
.adder {
  height: 35px !important;
  min-height: 35px !important;
}
</style>
